export default {
  Name: "",
  Description: "",
  Id: 0,
  IsEnabled: false,
  IsNull: false
};
